/**
 * WizardStepper — numbered progress indicator for the import wizard.
 * Hand-rolled (no shadcn stepper exists); presentation only.
 */

import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface WizardStepDescriptor {
  key: string;
  label: string;
}

interface Props {
  steps: ReadonlyArray<WizardStepDescriptor>;
  activeKey: string;
}

export function WizardStepper({ steps, activeKey }: Props) {
  const activeIndex = steps.findIndex((s) => s.key === activeKey);
  return (
    <ol className="flex items-center gap-1 sm:gap-2 overflow-x-auto" aria-label="Import steps">
      {steps.map((step, i) => {
        const done = i < activeIndex;
        const active = i === activeIndex;
        return (
          <li key={step.key} className="flex items-center gap-1 sm:gap-2 shrink-0">
            {i > 0 && <div className="h-px w-4 sm:w-8 bg-border" aria-hidden />}
            <div
              className={cn(
                'flex items-center gap-1.5 rounded-full px-2 py-1 text-xs',
                active && 'bg-primary text-primary-foreground font-medium',
                done && 'text-foreground',
                !active && !done && 'text-muted-foreground',
              )}
              aria-current={active ? 'step' : undefined}
            >
              <span
                className={cn(
                  'flex h-4 w-4 items-center justify-center rounded-full border text-[10px]',
                  active ? 'border-primary-foreground' : 'border-border',
                  done && 'bg-primary text-primary-foreground border-primary',
                )}
              >
                {done ? <Check className="h-3 w-3" /> : i + 1}
              </span>
              {step.label}
            </div>
          </li>
        );
      })}
    </ol>
  );
}
